module.exports = __webpack_public_path__ + "static/media/dudly_logo.b87a0413.jpg";